(function (scope) {
  'use strict';
  function endpointURL(value, allowLocalhost = false) {
    try {
      if (typeof value !== 'string' || !value.trim()) return null;
      const url = new URL(value);
      const local = allowLocalhost && ['localhost', '127.0.0.1', '[::1]'].includes(url.hostname);
      if ((url.protocol !== 'https:' && !(local && url.protocol === 'http:')) || url.username || url.password || url.search || url.hash) return null;
      if (!allowLocalhost && ['localhost', '127.0.0.1', '[::1]'].includes(url.hostname)) return null;
      return url;
    } catch (_) { return null; }
  }
  function productGID(id) {
    return /^[1-9]\d*$/.test(String(id)) ? `gid://shopify/Product/${id}` : null;
  }
  const productPattern = /^gid:\/\/shopify\/Product\/[1-9]\d*$/;
  function productIDs(value) {
    const ids = typeof value === 'string' ? value.split(',') : value;
    if (!Array.isArray(ids) || !ids.length || ids.length > 50 || ids.some(id => typeof id !== 'string' || !productPattern.test(id)) || new Set(ids).size !== ids.length) throw new Error('collectionGuidance');
    return ids;
  }
  function configuration(d) {
    const kind = d.kind || 'product';
    if (!['product', 'selected_product', 'series', 'shop', 'all', 'collection', 'selected_products'].includes(kind)) throw new Error('contextGuidance');
    if (d.defaultScope && !['product', 'series'].includes(d.defaultScope)) throw new Error('contextGuidance');
    if (d.showScopeSwitcher !== undefined && !['true', 'false'].includes(d.showScopeSwitcher)) throw new Error('contextGuidance');
    const contextual = ['product', 'selected_product', 'series'].includes(kind);
    const productId = kind === 'selected_product' ? d.selectedProductId : (kind === 'series' ? (d.selectedProductId || d.productId) : d.productId);
    if (contextual && !productGID(productId)) throw new Error('contextGuidance');
    const requiredSeries = contextual && (kind === 'series' || d.defaultScope === 'series');
    if (contextual && ((d.seriesId && !uuid(d.seriesId)) || (requiredSeries && !uuid(d.seriesId)))) throw new Error('seriesGuidance');
    let ids = null;
    if (kind === 'collection') ids = productIDs(d.collectionOverflow === 'true' ? '' : d.productIds);
    if (kind === 'selected_products') {
      try { ids = productIDs(d.selectedProductIds); } catch (_) { throw new Error('selectedProductsGuidance'); }
    }
    return { kind: contextual ? 'product' : (['collection', 'selected_products'].includes(kind) ? 'products' : kind), productId, ids,
      contextual, requiredSeries, configuredSeries: contextual && !!d.seriesId, switcher: contextual && d.showScopeSwitcher !== 'false' };
  }
  function positiveInteger(value) { return Number.isSafeInteger(value) && value > 0; }
  function requestURL(endpoint, productId, page = 1, rating = '', sort = 'newest', kind = 'product', seriesId = null, productIds = null) {
    const url = endpointURL(endpoint);
    if (!url || !positiveInteger(page) || !['', '1', '2', '3', '4', '5'].includes(String(rating)) || !['newest', 'highest', 'lowest'].includes(sort) || !['product', 'products', 'shop', 'all'].includes(kind)) throw new Error('Invalid request');
    url.pathname = url.pathname.replace(/\/$/, '') + '/api/public/reviews';
    if (kind === 'product') {
      const gid = productGID(productId);
      if (!gid) throw new Error('Invalid product');
      url.searchParams.set('product_id', gid);
      if (seriesId !== null) {
        if (!uuid(seriesId)) throw new Error('Invalid series');
        url.searchParams.set('scope', 'series'); url.searchParams.set('series_id', seriesId);
      }
    } else {
      if (seriesId !== null) throw new Error('Invalid scope');
      url.searchParams.set('kind', kind);
      if (kind === 'products') url.searchParams.set('product_ids', productIDs(productIds).join(','));
    }
    url.searchParams.set('page', String(page));
    url.searchParams.set('page_size', '10');
    url.searchParams.set('rating', String(rating));
    url.searchParams.set('sort', sort);
    return url.href;
  }
  function uuid(value) { return typeof value === 'string' && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value); }
  function name(value) { return typeof value === 'string' && value.trim().length > 0; }
  function originalProduct(value) { return value && typeof value.id === 'string' && /^gid:\/\/shopify\/Product\/[1-9]\d*$/.test(value.id) && name(value.name); }
  function discoveryURL(endpoint, productId) {
    const url = new URL(requestURL(endpoint, productId));
    url.pathname = url.pathname.replace(/reviews$/, 'review-series');
    for (const key of ['page', 'page_size', 'rating', 'sort']) url.searchParams.delete(key);
    return url.href;
  }
  function parseDiscovery(data) {
    if (!data || !Array.isArray(data.series)) throw new Error('Invalid series');
    const ids = new Set();
    for (const item of data.series) {
      if (!item || !uuid(item.id) || !name(item.name) || !Number.isSafeInteger(item.count) || item.count < 0 || ids.has(item.id.toLowerCase())) throw new Error('Invalid series');
      ids.add(item.id.toLowerCase());
    }
    return data.series;
  }
  function mediaURL(value, endpoint) {
    try {
      const base = endpointURL(endpoint);
      // Check the original spelling before URL parsing can normalize traversal or slashes.
      if (!base || typeof value !== 'string' || /[\s\\?#\u0000-\u001f\u007f]/.test(value)) return null;
      const uuid = '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}';
      if (new RegExp(`^/api/public/reviews/${uuid}/media/${uuid}$`).test(value)) return new URL(value, base.origin).href;
      const absolute = /^https:\/\/([^/]+)(\/.*)?$/i.exec(value);
      if (!absolute || absolute[1].includes('@')) return null;
      let path = absolute[2] || '/';
      // Repeated encodings must not conceal separators, dot segments or active files.
      for (let depth = 0; ; depth++) {
        if (/[\\?#\u0000-\u001f\u007f]/.test(path) || /%2f|%5c/i.test(path) || path.split('/').some(part => part === '.' || part === '..') || /\.(?:svg|svgz|js|mjs|cjs|html|htm|xhtml|xml|xsl|xslt|swf|mht|mhtml|php\d*|phtml|asp|aspx|jsp|jspx|shtml)(?:$|[/.;])/i.test(path)) return null;
        const decoded = decodeURIComponent(path);
        if (decoded === path) break;
        if (depth >= 5) return null;
        path = decoded;
      }
      const url = new URL(value);
      if (url.protocol !== 'https:' || url.origin !== base.origin || url.username || url.password || url.search || url.hash) return null;
      return url.href;
    } catch (_) { return null; }
  }
  function purchasedItem(value) {
    if (!value || typeof value.product_id !== 'string' || !productPattern.test(value.product_id) || !(value.variant_id === null || (typeof value.variant_id === 'string' && /^gid:\/\/shopify\/ProductVariant\/[1-9]\d*$/.test(value.variant_id))) || !name(value.product_title) || typeof value.variant_title !== 'string' || !Array.isArray(value.options) || value.options.some(o => !o || !name(o.name) || typeof o.value !== 'string') || !['current_variant', 'product', 'none'].includes(value.image_kind) || !(value.image_url === null || typeof value.image_url === 'string')) throw new Error('Invalid purchased item');
    return value;
  }
  function purchasedImageURL(value, endpoint) {
    // Own media is restricted to the exact public media route, never arbitrary own paths.
    if (typeof value !== 'string') return null;
    const own = mediaURL(value, endpoint);
    if (own && mediaURL(new URL(own).pathname, endpoint)) return own;
    if (!value.startsWith('https://cdn.shopify.com/')) return null;
    const safe = mediaURL(value, 'https://cdn.shopify.com');
    // Only raster product assets; a query is deliberately not accepted.
    return safe && /\.(?:png|jpe?g|webp|avif|gif)$/i.test(new URL(safe).pathname) ? safe : null;
  }
  // All customer strings take this exact path; never parse customer content as HTML.
  function setText(node, value) { node.textContent = typeof value === 'string' ? value : ''; return node; }
  function pagination(value) {
    if (!value || !positiveInteger(value.page) || value.page_size !== 10 || !Number.isSafeInteger(value.total) || value.total < 0) throw new Error('Invalid pagination');
    const pages = Math.max(1, Math.ceil(value.total / value.page_size));
    if (value.page > pages) throw new Error('Invalid page');
    return { ...value, pages, previous: value.page > 1, next: value.page < pages };
  }
  function parseData(data, selected = null, kind = 'product', ids = null) {
    if (kind === 'products') {
      if (!Array.isArray(data?.scope?.product_ids)) throw new Error('Invalid products scope');
      const expected = productIDs(ids);
      const actual = productIDs(data?.scope?.product_ids);
      if (selected || data.scope.kind !== 'products' || expected.length !== actual.length || expected.some(id => !actual.includes(id))) throw new Error('Invalid products scope');
    }
    if (kind === 'all' && selected) throw new Error('Invalid scope');
    if (selected) {
      if (!uuid(selected.id) || !name(selected.name) || data?.scope?.kind !== 'series' || data.scope.id !== selected.id || data.scope.name !== selected.name) throw new Error('Invalid scope');
    } else if (data?.scope !== undefined && (!data.scope || data.scope.kind !== kind)) throw new Error('Invalid scope');
    if (!data || !Array.isArray(data.reviews) || data.reviews.length > 10) throw new Error('Invalid reviews');
    const p = pagination(data.pagination), s = data.summary;
    if (!s || !Number.isSafeInteger(s.count) || s.count < 0 || (s.count > 0 && (typeof s.average !== 'number' || !Number.isFinite(s.average) || s.average < 1 || s.average > 5))) throw new Error('Invalid summary');
    for (let i = 1; i <= 5; i++) if (!Number.isSafeInteger(s.distribution?.[i]) || s.distribution[i] < 0) throw new Error('Invalid distribution');
    if (kind === 'products' && (Object.values(s.distribution).reduce((sum, n) => sum + n, 0) !== s.count || p.total > s.count)) throw new Error('Invalid products summary');
    for (const r of data.reviews) if (!r || typeof r.display_name !== 'string' || typeof r.body !== 'string' || ('title' in r && typeof r.title !== 'string') || !Number.isInteger(r.rating) || r.rating < 1 || r.rating > 5 || (r.reply != null && typeof r.reply !== 'string') || !Array.isArray(r.media)) throw new Error('Invalid review');
    const reviewIds = new Set();
    for (const r of data.reviews) {
      if (kind === 'products' && (!originalProduct(r.original_product) || !ids.includes(r.original_product.id))) throw new Error('Invalid collection product');
      if (r.purchased_item != null) purchasedItem(r.purchased_item);
      if (kind === 'all') {
        if (!uuid(r.id) || reviewIds.has(r.id.toLowerCase()) || !['product', 'shop'].includes(r.review_kind)) throw new Error('Invalid review kind');
        reviewIds.add(r.id.toLowerCase());
        if (r.review_kind === 'product' ? !originalProduct(r.original_product) : r.original_product !== null) throw new Error('Invalid original product');
      } else if ((selected || r.original_product !== undefined) && !originalProduct(r.original_product)) throw new Error('Invalid original product');
    }
    return { reviews: data.reviews, pagination: p, summary: s, ...(selected ? { scope: data.scope } : {}) };
  }
  function requestGate() {
    let sequence = 0, active;
    return {
      start() { active?.abort(); active = new AbortController(); const id = ++sequence; return { signal: active.signal, current: () => id === sequence }; },
      cancel() { ++sequence; active?.abort(); }
    };
  }
  function productRating(summary, selected, rating, kind) {
    if (selected || rating || kind !== 'product' || !Number.isSafeInteger(summary?.count) || summary.count <= 0 || !Number.isFinite(summary.average) || summary.average < 1 || summary.average > 5) return null;
    return { '@type': 'AggregateRating', ratingValue: Number(summary.average.toFixed(1)), reviewCount: summary.count, bestRating: 5, worstRating: 1 };
  }
  const helpers = { productRating, endpointURL, productGID, requestURL, mediaURL, setText, pagination, parseData, requestGate, uuid, discoveryURL, parseDiscovery, configuration, productIDs, purchasedItem, purchasedImageURL };
  if (typeof module !== 'undefined' && module.exports) module.exports = helpers;
  if (!scope.customElements || scope.customElements.get('two-nu-reviews')) return;
  class Reviews extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.copy = JSON.parse(this.dataset.copy || '{}');
      this.gate = requestGate(); this.discoveryGate = requestGate();
      this.selected = null; this.series = []; this.validatedContext = null;
      this.page = 1; this.rating = ''; this.sort = 'newest';
      this.querySelector('[data-sort]').value = this.sort;
      this.events = new AbortController();
      this.addEventListener('click', (event) => this.click(event), { signal: this.events.signal });
      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-sort]')) { this.sort = event.target.value; this.page = 1; this.load(); }
      }, { signal: this.events.signal });
      this.renderScopes();
      try {
        const config = configuration(this.dataset);
        if (config.requiredSeries || config.configuredSeries) this.discover();
        else { this.load(); if (config.contextual && (config.switcher || this.dataset.seriesId)) this.discover(); }
      } catch (error) { this.configurationError(error.message); }
    }
    disconnectedCallback() { this.gate?.cancel(); this.discoveryGate?.cancel(); this.events?.abort(); this.closeLightbox(); this.initialized = false; }
    contextKey() { return JSON.stringify([this.dataset.endpoint, this.dataset.productId, this.dataset.selectedProductId, this.dataset.kind, this.dataset.productIds, this.dataset.selectedProductIds, this.dataset.designMode, this.dataset.collectionOverflow, this.dataset.seriesId, this.dataset.defaultScope, this.dataset.showScopeSwitcher, this.selected?.id || null]); }
    renderScopes() {
      const controls = this.querySelector('[data-scopes]');
      if (!controls) return;
      const active = document.activeElement;
      const focusId = controls.contains?.(active) ? (active.dataset.seriesId || 'product') : null;
      controls.replaceChildren();
      let config; try { config = configuration(this.dataset); } catch (_) { controls.hidden = true; return; }
      controls.hidden = !config.switcher;
      if (!config.contextual) {
        setText(this.querySelector('[data-scope-status]'), '');
        this.querySelector('[data-series-note]').hidden = true;
        return;
      }
      if (!controls.hidden) {
        const product = this.button(this.copy.thisProduct, 'product');
        product.setAttribute('aria-pressed', String(!this.selected)); controls.append(product);
        for (const series of this.series) {
          const b = this.button(this.format('seriesChoice', { name: series.name, count: this.number(series.count) }), 'series');
          b.dataset.seriesId = series.id; b.setAttribute('aria-pressed', String(this.selected?.id === series.id)); controls.append(b);
        }
      }
      if (focusId) Array.from(controls.childNodes).find(b => (b.dataset.seriesId || 'product') === focusId)?.focus();
      const status = this.querySelector('[data-scope-status]');
      if (status) setText(status, this.selected ? this.format('seriesSelected', { name: this.selected.name }) : this.copy.productSelected);
      const note = this.querySelector('[data-series-note]');
      if (note) { note.hidden = !this.selected; setText(note, this.copy.seriesExplanation); }
    }
    async discover() {
      let config; try { config = configuration(this.dataset); } catch (error) { this.configurationError(error.message); return; }
      if (!config.contextual) return;
      this.validatedContext = null;
      if (config.requiredSeries || config.configuredSeries) { this.status('loading'); this.setAttribute('aria-busy', 'true'); }
      const gate = this.discoveryGate, ticket = gate.start(), key = this.contextKey();
      const current = () => ticket.current() && key === this.contextKey();
      const timeout = setTimeout(() => { if (current()) { gate.cancel(); if (config.requiredSeries || config.configuredSeries) this.configurationError('seriesGuidance'); } }, 12000);
      try {
        const response = await fetch(discoveryURL(this.dataset.endpoint, config.productId), { signal: ticket.signal, credentials: 'omit', redirect: 'error', headers: { Accept: 'application/json' }, referrerPolicy: 'no-referrer' });
        if (!response.ok) throw new Error('Unavailable');
        const series = parseDiscovery(await response.json());
        if (!current()) return;
        const chosen = this.dataset.seriesId ? series.find(item => item.id === this.dataset.seriesId) : null;
        if (this.dataset.seriesId && !chosen) throw new Error('seriesGuidance');
        this.series = chosen ? [chosen] : series;
        this.validatedContext = JSON.stringify([this.dataset.endpoint, config.productId, this.dataset.seriesId || null]);
        if (config.requiredSeries) this.selected = chosen;
        this.renderScopes();
        if (config.requiredSeries || config.configuredSeries) this.load();
      } catch (_) { if (current() && (config.requiredSeries || config.configuredSeries)) this.configurationError('seriesGuidance'); }
      finally { clearTimeout(timeout); }
    }
    selectScope(selected) {
      let config; try { config = configuration(this.dataset); } catch (_) { return; }
      if (!config.switcher || (selected && !this.series.includes(selected))) return;
      if ((this.selected?.id || null) === (selected?.id || null)) return;
      this.discoveryGate?.cancel(); this.closeLightbox();
      this.selected = selected; this.page = 1; this.rating = ''; this.sort = 'newest'; this.restoreRatingFocus = false;
      this.querySelector('[data-sort]').value = this.sort;
      this.renderScopes(); return this.load();
    }
    el(tag, text, className) {
      const node = document.createElement(tag);
      if (text !== undefined) setText(node, text);
      if (className) node.className = className;
      return node;
    }
    format(key, values = {}) { return (this.copy[key] || '').replace(/\{(\w+)\}/g, (match, key) => values[key] === undefined ? match : String(values[key])); }
    number(value, decimals = 0) {
      try { return new Intl.NumberFormat(this.dataset.locale, { maximumFractionDigits: decimals }).format(value); }
      catch (_) { return String(value); }
    }
    stars(rating) {
      const node = this.el('span', '★'.repeat(Math.round(rating)) + '☆'.repeat(5 - Math.round(rating)), 'tnr-stars');
      node.setAttribute('role', 'img'); node.setAttribute('aria-label', this.format('stars', { rating: this.number(rating, 1) }));
      return node;
    }
    button(text, action) { const b = this.el('button', text); b.type = 'button'; b.dataset.action = action; return b; }
    status(key) { setText(this.querySelector('[data-status]'), this.copy[key]); }
    async load() {
      const gate = this.gate, ticket = gate.start(), key = this.contextKey();
      const selected = this.selected || null;
      const current = () => ticket.current() && key === this.contextKey();
      this.closeLightbox();
      if (this.dataset.kind === 'product') {
        const schema = scope.document?.querySelector?.('script[data-two-nu-product-schema="' + this.dataset.productId + '"]');
        if (schema) {
          try { const product = JSON.parse(schema.textContent); delete product.aggregateRating; schema.textContent = JSON.stringify(product).replace(/</g, '\\u003c'); } catch (_) {}
        }
      }
      this.querySelector('[data-results]').replaceChildren();
      this.querySelector('[data-pagination]').replaceChildren();
      this.querySelector('[data-summary]').replaceChildren();
      this.setAttribute('aria-busy', 'true'); this.status('loading');
      // Timeout invalidates the ticket and displays its terminal state.
      let timedOut = false;
      const timeout = setTimeout(() => { if (current()) { timedOut = true; gate.cancel(); this.setAttribute('aria-busy', 'false'); this.error(); } }, 12000);
      try {
        const config = configuration(this.dataset);
        if ((selected || config.requiredSeries || config.configuredSeries) && this.validatedContext !== JSON.stringify([this.dataset.endpoint, config.productId, this.dataset.seriesId || null])) throw new Error('seriesGuidance');
        const url = requestURL(this.dataset.endpoint, config.productId, this.page, this.rating, this.sort, config.kind, selected?.id || null, config.ids);
        const response = await fetch(url, { signal: ticket.signal, credentials: 'omit', redirect: 'error', headers: { Accept: 'application/json' }, referrerPolicy: 'no-referrer' });
        if (!response.ok) throw new Error('Unavailable');
        const data = parseData(await response.json(), selected, config.kind, config.ids);
        if (!current()) return;
        if (data.pagination.page !== this.page) throw new Error('Unexpected page');
        this.render(data);
        // Only the visible, unfiltered current-product summary belongs to this Product.
        const schema = scope.document?.querySelector?.('script[data-two-nu-product-schema="' + this.dataset.productId + '"]');
        if (schema && this.dataset.kind === 'product') {
          try {
            const product = JSON.parse(schema.textContent);
            delete product.aggregateRating;
            const aggregate = productRating(data.summary, selected, this.rating, config.kind);
            if (aggregate) product.aggregateRating = aggregate;
            schema.textContent = JSON.stringify(product).replace(/</g, '\\u003c');
          } catch (_) { /* Preserve the existing product record on malformed markup. */ }
        }
      } catch (error) { if (current() && !timedOut) { if (['contextGuidance', 'seriesGuidance', 'collectionGuidance', 'selectedProductsGuidance'].includes(error.message)) this.configurationError(error.message); else this.error(); } }
      finally { clearTimeout(timeout); if (current()) this.setAttribute('aria-busy', 'false'); }
    }
    configurationError(key) {
      this.gate?.cancel(); this.discoveryGate?.cancel(); this.closeLightbox(); this.validatedContext = null;
      for (const selector of ['[data-results]', '[data-pagination]', '[data-summary]', '[data-scopes]']) this.querySelector(selector).replaceChildren();
      this.setAttribute('aria-busy', 'false'); this.status(this.dataset.designMode === 'true' ? key : 'unavailable');
      setText(this.querySelector('[data-scope-status]'), ''); this.querySelector('[data-series-note]').hidden = true;
    }
    error() { this.status('unavailable'); this.querySelector('[data-pagination]').replaceChildren(this.button(this.copy.retry, 'retry')); }
    render(data) {
      const summary = this.querySelector('[data-summary]'), s = data.summary;
      const overview = this.el(this.dataset.summaryMarkup === 'true' ? 'dl' : 'div', undefined, 'tnr-overview');
      if (s.count > 0) { overview.append(this.stars(s.average), this.el('strong', this.number(s.average, 1))); }
      overview.append(this.el('span', this.format('count', { count: this.number(s.count) })));
      const summaryLabel = data.scope ? this.format('seriesSummary', { name: data.scope.name }) : (this.dataset.kind === 'selected_products' ? this.copy.selectedProductsSummary : (this.dataset.kind === 'collection' ? this.copy.collectionSummary : (this.dataset.kind === 'all' ? this.copy.storeSummary : (this.dataset.kind === 'shop' ? this.copy.summaryLabel : this.copy.productSummary))));
      // Optional semantic summary only: no Product or aggregate SEO records are emitted.
      if (overview.tagName === 'DL') {
        const label = this.el('dt', summaryLabel), detail = this.el('dd');
        detail.append(...overview.childNodes); overview.replaceChildren(label, detail);
      }
      if (overview.tagName !== 'DL') overview.append(this.el('span', summaryLabel, 'tnr-summary-label'));
      summary.append(overview);
      const distribution = this.el('div', undefined, 'tnr-distribution');
      const all = this.button(this.copy.allRatings, 'rating'); all.dataset.rating = ''; all.setAttribute('aria-pressed', String(this.rating === '')); distribution.append(all);
      for (let i = 5; i >= 1; i--) {
        const b = this.button(this.format('distribution', { rating: this.number(i), count: this.number(s.distribution[i]) }), 'rating');
        b.dataset.rating = String(i); b.setAttribute('aria-pressed', String(this.rating === String(i)));
        const meter = this.el('span', undefined, 'tnr-bar'); meter.setAttribute('aria-hidden', 'true');
        const fill = this.el('span'); fill.style.width = `${s.count ? Math.min(100, s.distribution[i] / s.count * 100) : 0}%`; meter.append(fill); b.append(meter); distribution.append(b);
      }
      summary.append(distribution);
      if (this.restoreRatingFocus) {
        Array.from(distribution.querySelectorAll('button')).find(b => b.dataset.rating === this.rating)?.focus();
        this.restoreRatingFocus = false;
      }
      const results = this.querySelector('[data-results]');
      for (const r of data.reviews) {
        const card = this.el('article', undefined, 'tnr-card');
        const header = this.el('div', undefined, 'tnr-card-header'); header.append(this.el('strong', r.display_name));
        if (typeof r.review_date === 'string' && /^\d{4}-\d{2}-\d{2}(?:T.*)?$/.test(r.review_date)) {
          const date = new Date(r.review_date);
          if (Number.isFinite(date.getTime())) {
            const time = this.el('time'); time.dateTime = r.review_date;
            try { setText(time, new Intl.DateTimeFormat(this.dataset.locale, { dateStyle: 'medium', timeZone: 'UTC' }).format(date)); } catch (_) { setText(time, r.review_date.slice(0, 10)); }
            header.append(time);
          }
        }
        card.append(header, this.stars(r.rating));
        if (this.dataset.kind === 'all' && r.review_kind === 'shop') card.append(this.el('p', this.copy.shopReview, 'tnr-shop-review'));
        if (data.scope || ['collection', 'selected_products'].includes(this.dataset.kind) || (this.dataset.kind === 'all' && r.review_kind === 'product')) card.append(this.el('p', this.format('originalProduct', { name: r.original_product.name }), 'tnr-original-product'));
        if (r.title) card.append(this.el('h3', r.title, 'tnr-title'));
        card.append(this.el('p', r.body, 'tnr-body'));
        if (r.reply !== null && r.reply !== undefined && r.reply !== '') {
          const reply = this.el('div', undefined, 'tnr-reply'); reply.append(this.el('strong', this.copy.replyLabel), this.el('p', r.reply, 'tnr-body')); card.append(reply);
        }
        if (r.purchased_item != null) card.append(this.renderPurchasedItem(r.purchased_item));
        const photos = this.el('div', undefined, 'tnr-photos');
        for (const media of r.media) {
          if (!media || media.kind !== 'image') continue;
          const url = mediaURL(media.url, this.dataset.endpoint); if (!url) continue;
          const alt = typeof media.alt === 'string' ? media.alt : this.copy.photo;
          const b = this.button(this.copy.openPhoto, 'photo'); b.dataset.url = url; b.dataset.alt = alt; b.setAttribute('aria-label', this.copy.openPhoto);
          const img = this.el('img'); img.src = url; img.alt = alt; img.loading = 'lazy'; img.referrerPolicy = 'no-referrer';
          b.replaceChildren(img); photos.append(b);
        }
        if (photos.childElementCount) {
          if (r.purchased_item != null) card.append(this.el('h4', this.copy.customerPhotos));
          card.append(photos);
        }
        results.append(card);
      }
      this.status(data.reviews.length ? 'loaded' : 'empty');
      const nav = this.querySelector('[data-pagination]'), p = data.pagination;
      const prev = this.button(this.copy.previous, 'previous'), next = this.button(this.copy.next, 'next'); prev.disabled = !p.previous; next.disabled = !p.next;
      nav.append(prev, this.el('span', this.format('page', { page: this.number(p.page), pages: this.number(p.pages) })), next);
    }
    renderPurchasedItem(item) {
      const node = this.el('section', undefined, 'tnr-purchased-item');
      node.setAttribute('aria-label', this.copy.purchasedItem);
      node.append(this.el('h4', this.copy.purchasedItem), this.el('p', item.product_title));
      if (item.variant_title) node.append(this.el('p', item.variant_title));
      for (const option of item.options) node.append(this.el('p', `${option.name}: ${option.value}`));
      const url = item.image_kind === 'none' ? null : purchasedImageURL(item.image_url, this.dataset.endpoint);
      if (url) {
        const label = item.image_kind === 'current_variant' ? this.copy.currentVariantImage : this.copy.currentProductImage;
        const image = this.el('img'); image.src = url; image.alt = `${item.product_title}. ${label}. ${this.copy.currentImageNote}`; image.loading = 'lazy'; image.referrerPolicy = 'no-referrer';
        node.append(image, this.el('p', label), this.el('p', this.copy.currentImageNote));
      } else node.append(this.el('p', this.copy.noItemImage));
      return node;
    }
    click(event) {
      const b = event.target.closest('button[data-action]'); if (!b || !this.contains(b)) return;
      switch (b.dataset.action) {
        case 'product': this.selectScope(null); break;
        case 'series': { const series = this.series.find(item => item.id === b.dataset.seriesId); if (series) this.selectScope(series); break; }
        case 'rating': this.restoreRatingFocus = true; this.rating = b.dataset.rating; this.page = 1; this.load(); break;
        case 'previous': this.page = Math.max(1, this.page - 1); this.load(); break;
        case 'next': this.page++; this.load(); break;
        case 'retry': this.load(); break;
        case 'photo': this.openLightbox(b); break;
      }
    }
    openLightbox(trigger) {
      const url = mediaURL(trigger.dataset.url, this.dataset.endpoint); if (!url || !trigger.isConnected || !this.contains(trigger)) return;
      this.closeLightbox();
      const dialog = this.el('dialog', undefined, 'tnr-lightbox'); dialog.setAttribute('aria-label', this.copy.photo);
      const close = this.button(this.copy.close, 'close');
      const img = this.el('img'); img.src = url; img.alt = trigger.dataset.alt; img.referrerPolicy = 'no-referrer';
      dialog.append(close, img); this.append(dialog); this.dialog = dialog; this.photoTrigger = trigger;
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => this.closeLightbox());
      dialog.showModal(); close.focus();
    }
    closeLightbox() {
      if (!this.dialog) return;
      const dialog = this.dialog; this.dialog = null; dialog.remove();
      if (this.photoTrigger?.isConnected) this.photoTrigger.focus(); this.photoTrigger = null;
    }
  }
  scope.customElements.define('two-nu-reviews', Reviews);
})(typeof window !== 'undefined' ? window : globalThis);

